export default __webpack_public_path__ + "assets/493f10d9082676f101093f06a26f53d0.svg";